module.exports = __webpack_public_path__ + "static/media/RVTN03.77ff5b1e.jpg";